'use strict';

module.exports = '1.0.3';


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/version.js
// module id = 1805
// module chunks = 7